/* import __COLOCATED_TEMPLATE__ from './see-how-apps-work-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();